/* Luluwala Kiri free-gift rules, enforced on every page (Calm Eden's gift engine).
   Gifts follow the number of Kiri pillows in the cart: Sleep Journal = 1 with every order, Cooling Silk Pillowcase = one per pillow,
   Silk Sleep Mask and Lavender Sachet = 1 at 2+, Sleep Socks = 1 at 4+ (Buy 3 Get 1 Free). No pillows in the cart means no gift lines. */
(function () {
  'use strict';
  if (window.ceGifts) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var UMB = 'kiri';
  var RULE = {
    68149162869015: function (u) { return u >= 1 ? 1 : 0; }, /* Sleep Journal with every order */
    68150934176023: function (u) { return u; }, /* Cooling Silk Pillowcase, one per pillow (owner 2026-10-29: "a cooling silk pillow case with buy 1") */
    68149164966167: function (u) { return u >= 2 ? 1 : 0; }, /* Silk Sleep Mask with Buy 2 and Buy 3 Get 1 Free */
    68150933029143: function (u) { return u >= 2 ? 1 : 0; }, /* Lavender Sachet with Buy 2 and Buy 3 Get 1 Free */
    68150933061911: function (u) { return u >= 4 ? 1 : 0; }, /* Sleep Socks with Buy 3 Get 1 Free */
    68149192425751: function () { return 0; }, /* Earplugs: not a gift (owner 2026-10-29) */
    68149192458519: function () { return 0; } /* Satin Bonnet: not a gift (owner 2026-10-29) */
  };
  var isGift = function (id) { return Object.prototype.hasOwnProperty.call(RULE, id); };

  /* fetch from a blank same-origin frame: the analytics add-to-cart hook does not see it, so gift lines are not counted as adds */
  var quiet = function () {
    try {
      var f = document.getElementById('ceQuietFrame');
      if (!f) { f = document.createElement('iframe'); f.id = 'ceQuietFrame'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.display = 'none'; document.body.appendChild(f); }
      return f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) { return window.fetch.bind(window); }
  };
  window.ceQuietFetch = window.ceQuietFetch || quiet;
  /* 2026-10-20 (Shopify Sidekick review): every cart write request is counted from the moment it is sent until the request itself
     settles (not when a code timeout gives up on it), and every one bumps a write number, so checkout can wait for writes that are
     really still on the wire and can tell that a write started (or started and finished) while it was reading the cart.
     Review 4: a write whose outcome is unknown (a network error, a 5xx, code that stopped waiting for it, or a page left while it was
     still on the wire) marks the cart "unsure" until the checkout confirmation (ce-suri-cart.js confirmCart) has read the true cart and
     shown it to the shopper. Time does not clear it and neither does a reload (it is kept for the tab in sessionStorage). The Clarity
     attribute stamp (o.attr) is counted while it runs but never marks the cart unsure: it changes no line. */
  var io = { n: 0, na: 0, gen: 0, gc: 0, unsure: false, unkAt: 0 };
  try { io.unsure = sessionStorage.getItem('ce_cart_unsure') === '1'; } catch (e) {}
  var unsure = function () { io.unsure = true; io.unkAt = Date.now(); try { sessionStorage.setItem('ce_cart_unsure', '1'); } catch (e) {} };
  window.ceCartIO = window.ceCartIO || {
    track: function (p, o) {
      var attr = !!(o && o.attr), d = false, fin = function () { if (!d) { d = true; io.n--; if (attr) io.na--; } };
      io.n++; io.gen++; if (attr) io.na++; else io.gc++;
      try { p.then(function (r) { fin(); if (!attr && r && r.status >= 500) unsure(); }, function () { fin(); if (!attr) unsure(); }); } catch (e) { fin(); }
      return p;
    },
    /* 2026-10-21 (Sidekick): purchasing checks count line-changing (commerce) requests only; attribute-only requests are still tracked */
    out: function () { return io.n - io.na; },
    generation: function () { return io.gc; },
    outAll: function () { return io.n; },
    unresolved: function () { return io.unsure; },
    clearUnresolved: function () { io.unsure = false; try { sessionStorage.removeItem('ce_cart_unsure'); } catch (e) {} },
    noteUnknown: unsure,
    sinceUnknown: function () { return io.unkAt ? Date.now() - io.unkAt : 1e9; }
  };
  window.addEventListener('pagehide', function () { if (io.n - io.na > 0) unsure(); });
  var track = function (p) { return window.ceCartIO.track(p); };

  var targets = function (cart) {
    var u = 0, have = {};
    (cart.items || []).forEach(function (it) {
      if (it.handle === UMB || it.handle === 'cloud-pillow') u += it.quantity;
      if (isGift(it.variant_id)) have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity;
    });
    var diff = {}, any = false;
    Object.keys(RULE).forEach(function (id) { var want = RULE[id](u); if ((have[id] || 0) !== want) { diff[id] = want; any = true; } });
    return any ? diff : null;
  };

  var running = null, failedKey = '', failedAt = 0;
  /* resolves { cart, changed } - cart is the corrected cart when a change was needed */
  var enforce = function (cart, force) {
    var diff = targets(cart);
    if (!diff) return Promise.resolve({ cart: cart, changed: false });
    var key = JSON.stringify(diff);
    /* audit 2026-10-16: a failed update may retry after 15 s; a call made while another update runs re-reads the cart and enforces again
       (2026-10-20: the checkout confirmation forces one more try) */
    if (!force && key === failedKey && Date.now() - failedAt < 15000) return Promise.resolve({ cart: cart, changed: false });
    if (running) return running.then(function () { return fetch(location.origin + ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { return targets(c) ? enforce(c) : { cart: c, changed: true }; }); });
    running = track(quiet()(location.origin + ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: diff }) }))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j || !j.items) throw j; return j; }); })
      .then(function (c) { failedKey = ''; return { cart: c, changed: true }; })
      .catch(function () { failedKey = key; failedAt = Date.now(); return { cart: cart, changed: false }; })
      .then(function (res) { running = null; return res; });
    return running;
  };

  var refreshDawn = function (cart) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var P = new DOMParser(), cd = document.querySelector('cart-drawer'), dst = document.querySelector('#CartDrawer');
      if (cd && dst && s['cart-drawer']) {
        var src = P.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (src) { dst.innerHTML = src.innerHTML; cd.classList.toggle('is-empty', cart.item_count === 0); var ov = dst.querySelector('#CartDrawer-Overlay'); if (ov && cd.close) ov.addEventListener('click', function () { cd.close(); }); }
      }
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) { var sec = P.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (sec) b.innerHTML = sec.innerHTML; }
    }).catch(function () {});
  };

  var check = function () {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(enforce)
      .then(function (res) { if (res.changed && !window.ceSuriCart) refreshDawn(res.cart); return res; });
  };

  window.ceGifts = { isGift: isGift, targets: targets, enforce: enforce, check: check, busy: function () { return !!running; } };

  /* pages without the Haven cart: check on load and after every cart change */
  var boot = function () {
    if (document.getElementById('csCart')) return;
    var t = 0, later = function () { clearTimeout(t); t = setTimeout(function () { check().catch(function () {}); }, 400); };
    var isCartMut = function (u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(u || '')); };
    var of = window.fetch;
    if (of) window.fetch = function (input, init) { var p = of.apply(this, arguments); try { var u = typeof input === 'string' ? input : (input && input.url); if (isCartMut(u)) p.then(later, function () {}); } catch (e) {} return p; };
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { if (isCartMut(u)) this.addEventListener('loadend', later); return oo.apply(this, arguments); };
    later();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
